export class Feedback {
    candidateIds: number[];
    feedback: string;
    status: number;
    constructor(candidateIds: number[], feedback: string, status: number) {
        this.candidateIds = candidateIds;
        this.feedback = feedback;
        this.status = status;
    }
}
